import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Header from "../Header/Header";
import PersonalizePanel from "./PersonalizePanel";
import { getStyles } from "./styles";
import { SiteDTO } from "@beable/roster-backend-client-v1";
import PersonalizeSheet from "./PersonalizeSheet";

export default function PersonalizeEvaluator() {
    const [site, setSite] = useState<SiteDTO | undefined>(undefined);
    const theme = useTheme();
    const styles = getStyles(theme);

    const handleSiteSelect = (site: SiteDTO): void => {
      setSite(site)
    }

    return (
        <Box sx={styles.root}>
            <Header />
            <PersonalizePanel
                onSiteSelect={handleSiteSelect}
            />
            <PersonalizeSheet site={site} />
        </Box>
    );
}
